import React, { Component } from "react"
import Slider from "react-slick"
import styled from "styled-components"
import GalleryLightbox from "./GalleryLightbox"
import { GatsbyImage } from "gatsby-plugin-image";

const SliderStyled = styled(Slider)`
    padding: 0 2rem;
    .slick-dots {
        height: auto;
        line-height: 10px;
        bottom: -1.5rem;
        margin: 0;
        padding: 0;
        width: auto;
        left: 50%;
        transform: translateX(-50%);
        &:before,
		&:after {
            content: '';  
            width: 6px;
            height: 6px;
            background: ${props => props.theme.colors.primary};
            border-radius: 50%;
            display: inline-block;
            vertical-align: middle;
            margin: 0 2.5px;
        }

        li {
            margin: 0 2.5px;
            width: auto;
            height: auto;
            vertical-align: middle;
            button {
                width: 10px;
                height: 10px;
                background: ${props => props.theme.colors.primary};
                border-radius: 50%;
                &:before {
                    display: none;
                }
            }
            &.slick-active button {
                background: ${props => props.theme.colors.secondary};
            }
        }
    }

    .slick-arrow {
        left: 0;

        &.slick-next {
            left: auto;
            right: 0;
        }
    }
`

const Slide = styled.button`
    border: 0;
    padding: 0;
`

class GallerySlider extends Component {

    constructor(props) {
        super(props)

        this.state = {
            modalOpen: false,
            activeImage: 0,
            navItemSize: 4
        }

        this.toggleModal = this.toggleModal.bind(this)
        this.navItemSize = this.navItemSize.bind(this)
    }

    componentDidMount() {
        this.navItemSize()

        window.addEventListener("resize", this.navItemSize,  {passive: true})
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.navItemSize, { passive: true })
    }

    navItemSize() {
        let size = 4
        if (window.innerWidth < 768) {
            size = 3
        }

        this.setState({
            navItemSize: size
        })
    }

    toggleModal() {
        this.setState({
            modalOpen: !this.state.modalOpen
        })
    }

    render() {
        const { images } = this.props


        //slider settings
        var settings = {
            dots: true,
            speed: 500,
            slidesToShow: this.state.navItemSize,
            slidesToScroll: 1, 
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: this.state.navItemSize,
                        slidesToScroll: 3
                    }
                }
            ]
        };
                  

        const sliderImages = images.map((image, i) => {

            return (
                <Slide key={i} 
                    className="px-1"                               
                    onClick={() => {
                    this.setState({
                        activeImage: i 
                    }, this.toggleModal())
                }}>
                    <GatsbyImage
                        image={image.localFile.childImageSharp.gatsbyImageData}
                        alt={image.altText} />
                </Slide>
            );
        })

        return(
            <>
                <SliderStyled {...settings}>
                    {sliderImages}
                </SliderStyled>
                <GalleryLightbox 
                    modalOpen={this.state.modalOpen} 
                    toggleModal={this.toggleModal} 
                    images={images} 
                    activeImage={this.state.activeImage}
                />
            </>
        )
    }
}

export default GallerySlider